import { Button } from '@solinkcorp/solink-ui/components/Button';
import { TestTube, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { env } from 'src/environment';
import useLocale from 'src/hooks/useLocale';
import FeaturesUtil from 'utils/FeaturesUtil';
import { getLocalizedJSX, getLocalizedStr } from 'utils/LocaleUtil';
import { type IntegrationBannerProps } from './IntegrationBanner';

export default function IntegrationBannerAspen(props: IntegrationBannerProps) {
  const locale = useLocale();

  return (
    <div
      role="status"
      className="tw flex h-[50px] w-full items-center gap-2 bg-status-yellow px-4 text-text-inverse"
    >
      <TestTube className="size-4 shrink-0" aria-hidden />
      <p className="min-w-0 flex-1 truncate body-md">
        {getLocalizedStr({
          string: locale.integrationBanner.usingIntegrationEnv,
          replacements: {
            environmentName: env.MODE,
          },
        })}{' '}
        {FeaturesUtil.hasDeveloperAccess() &&
          getLocalizedJSX(locale.integrationBanner.switchEnvInfo, {
            useIntegrationApi: (
              <span key="developer" className="body-md-strong">
                {locale.preferencesPage.developerTitle}
              </span>
            ),
            preferences: (
              <Link
                key="preferences"
                to="/settings/preferences"
                className="cursor-pointer underline underline-offset-2"
              >
                {locale.settingsPage.preferences}
              </Link>
            ),
          })}
      </p>
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        aria-label={locale.general.close}
        onClick={() => props.setIsIntegrationBannerVisible(false)}
        // Ghost hover is a neutral wash. Yellow-600 must win in both themes.
        className="shrink-0 text-text-inverse hover:bg-yellow-600 hover:text-text-inverse dark:hover:bg-yellow-600"
      >
        <X />
      </Button>
    </div>
  );
}
